import React from "react";
import PropTypes from "prop-types";

export default function TheTradeDesk(props) {
  return (
    <svg
      className={props.className}
      width={props.width}
      height={props.height}
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <polygon
          fill="#0099fa"
          points="5.9572,0.4652 5.9572,4.3714 9.9522,4.3714 9.9522,14.566 13.7973,14.566 13.7973,4.3103     13.7973,0.4652   "
        />
        <g>
          <path
            fill="#0099fa"
            d="m 3.8467 13.6592 c 0 -3.0409 1.6898 -5.687 4.1816 -7.0494 v -0.0004 h -5.7056 c -1.4592 1.9715 -2.3227 4.4088 -2.3227 7.0498 c 0 5.2401 3.3946 9.6862 8.1037 11.2626 v -4.1734 c -2.5328 -1.351 -4.257 -4.0179 -4.257 -7.0892"
          />
          <path
            fill="#0099fa"
            d="m 15.7221 2.424 v 4.185 c 2.4923 1.3631 4.1841 4.0088 4.1841 7.0508 c 0 4.4331 -3.5964 8.0286 -8.0309 8.0286 c -0.6614 0 -1.304 -0.0805 -1.9188 -0.231 v 3.9224 c 0.6251 0.1007 1.2653 0.155 1.9188 0.155 c 6.5583 0 11.8756 -5.3168 11.8756 -11.8749 c -0.0001 -5.2129 -3.3585 -9.6376 -8.0288 -11.2359"
          />
        </g>
      </g>
    </svg>
  );
}

TheTradeDesk.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

TheTradeDesk.defaultProps = {
  className: "",
  width: 40,
  height: 40
};
